import {
  TBW_INVESTIGATE_ONLY,
  TBW_INVESTIGATE_WITH_WARN,
  SHOW_TBW_INVESTIGATE_BUTTON
} from "../../../../../constants/input-entries-constants";
import getTBWStore from "../../../../../stores/tbw-store";
import getCoreHistoryStore from "../../../../../stores/core/core-history-store";
import Et3Button from "../../../../et3-button";
import { withLiteObserverAndTheme } from "../../../../et3-enhanced-render";

const InvestigateButton = withLiteObserverAndTheme(() => {
  const pageName = getCoreHistoryStore().pageName.get();
  const TBWFromCase = getTBWStore().TBWFromCase.get();
  const shouldDisable = getTBWStore().disableTbwActionButton.get();
  const investigateOnly = TBW_INVESTIGATE_ONLY.indexOf(TBWFromCase) > -1;
  const investigateWithWarn =
    TBW_INVESTIGATE_WITH_WARN.indexOf(TBWFromCase) > -1;
  const shouldShow =
    SHOW_TBW_INVESTIGATE_BUTTON.indexOf(TBWFromCase) > -1 &&
    pageName != "INVESTIGATION_CASES";

  return shouldShow ? (
    <Et3Button
      isEnabled={!shouldDisable}
      onClick={async () => {
        return await getTBWStore().handleInvestigationAndWarning({
          investigateOnly,
          investigateWithWarn
        });
      }}
      size="MEDIUM"
      type="WARN"
      text="INVESTIGATE"
    />
  ) : null;
});

export default InvestigateButton;
